<template>
  <div>
    <section
      id="theSlide"
      style="height: 490px; padding-left:  75px; padding-right: 75px;     margin-top: 30px;"
    >
      <div class="clear"></div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-12" style="margin: 0 auto;">
          <hooper
            :autoPlay="true"
            :mouseDrag="false"
            :playSpeed="15000"
            :transition="1000"
            :infiniteScroll="true"
            :centerMode="true"
            :shortDrag="false"
            :touchDrag="false"
            :wheelControl="false"
          >
            <slide style="background-color:#333; height: fit !important;">
              <img :src="getFullPath('wintershop_v3_1.jpg')" alt="Image" />
            </slide>
            <slide style="background-color:#555; max-height: 490px;">
              <img :src="getFullPath('wintershop_v3_2.jpg')" alt="Image" />
            </slide>
            <slide style="background-color:#444;">
              <img :src="getFullPath('wintershop_v3_3.jpg')" alt="Image" />
            </slide>
            <slide style="background-color:#555;">
              <img :src="getFullPath('wintershop_v3_4.jpg')" alt="Image" />
            </slide>

            <hooper-navigation slot="hooper-addons"></hooper-navigation>
            <hooper-pagination slot="hooper-addons"></hooper-pagination>
          </hooper>
        </div>
      </div>
    </section>
    <!-- Shop Categories
    =============================================-->
    <section id="content" style="margin-top:60px;">
      <div class="content-wrap">
        <div class="container clearfix">
          <div class="row">
            <div class="col-lg-8 col-md-8 col-12">
              <div class="row">
                <div class="col-lg-6 col-12 norightpadding">
                  <img
                    @click="$router.push('/rental-list/อื่นๆ')"
                    style="cursor:pointer"
                    :src="getFullPath('Accessory_v3.jpg')"
                    alt="Image"
                  />
                </div>

                <div
                  class="col-lg-6 col-12 norightpadding nosmpadding"
                  style="margin-bottom: 15px;"
                >
                  <img
                    @click="$router.push('/rental-list/พลัสไซส์')"
                    style="cursor:pointer"
                    :src="getFullPath('Specialsize_v3.jpg')"
                    alt="Image"
                  />
                </div>

                <div class="w-100"></div>

                <div class="col-lg-12 norightpadding">
                  <img
                    @click="$router.push('/rental-list/ผู้ชาย')"
                    style="cursor:pointer"
                    :src="getFullPath('male_03.jpg')"
                    alt="Image"
                  />
                </div>
              </div>
            </div>

            <div
              class="col-lg-4 col-12 nosmpadding"
              style="padding-right:0; padding-left: 0; background-color: #ffd1d7; padding-top: 18px;"
            >
              <img
                @click="$router.push('/rental-list/ผู้หญิง')"
                style="cursor:pointer"
                :src="getFullPath('female_v4.jpg')"
                alt="Image"
              />
            </div>
          </div>
          <div class="row" style="margin-top: 50px;">
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left;">
              <h4 style="font-size: 36px; margin-bottom: 0;">New Arrivals</h4>
            </div>
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left; ">
              <h3
                style="font-size: 20px; font-family:'supermarket'; color: #bcbcbd; margin-bottom: 0;"
              >
                สินค้ามาใหม่
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="clear"></div>

    <!----------------------------------------------------------------->

    <!-- Shop Item 1
    =============================================-->
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <b-field label="Select a date">
            <b-datepicker
              placeholder="Click to select..."
              v-model="dates"
              range
            >
            </b-datepicker>
          </b-field>
        </div>
      </div>
    </section>

    <div
      class="row rowdata1 grid-6"
      style="max-width: 1100px; margin-left:auto; margin-right: auto;"
    >
      <div
        v-for="(item, ind) in items"
        :key="ind"
        class="col-lg-3 col-md-3 col-6"
      >
        <div
          class="product iproduct clearfix imagefocus"
          style="border: 1px solid #f0f0f0;"
        >
          <form action="shop-single.html">
            <div class="product-image" style="height: 250px; ">
              <!-- <a href="javascript:sendData('{{ item.productItemId }}')"><img :src="getFullPath(item.mainImage)" alt="Image 2"></a> -->
              <img
                :src="getProductPath(item.mainImage)"
                alt="Image 2"
                style="width:85%; margin: 10px auto; height:auto; cursor:pointer;"
                @click="moveTo(item.groupId)"
              />
            </div>
            <div class="product-desc">
              <input
                type="hidden"
                name="wproduct"
                :value="getProductID(item.productItemId)"
              />
              <input
                type="submit"
                :value="getProductName(item.name)"
                style="    border: 0;
											background-color: white;     display: flex; margin: auto;"
              />

              <!-- <div class="product-title mb-1"><h3><a href="#">{{ item.name }}</a></h3></div> -->
              <div class="product-price font-primary">
                <ins>{{ formatPrice(item.rentalPrice) }} บาท</ins>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="clear bottommargin-sm"></div>

    <div
      class="row topmargin clearfix"
      style="margin-left:auto; margin-right:auto; max-width: 1100px; margin-bottom: 40px;"
    >
      <div id="features">
        <img
          :src="getFullPath('Why-Wintershop.jpg')"
          style=" width: 100%;  height: auto !important;"
        />
      </div>
    </div>

    <!-- FOOT 
    =============================================-->
    <!-- <div class="row" style="max-width: 1100px; margin-left: auto; margin-right: auto;">
      <div class="col-lg-3 col-md-3 col-6" style="text-align: center; ">
        <img :src="getFullPath('lo3_1.png')" alt="Wintershop Thailand" style="margin-right: 20px;" />
      </div>

      <div class="col-lg-3 col-md-3 col-6">
        <div class="fancy-title title-border">
          <h4>ร้าน Wintershop</h4>
        </div>
        <p>
          พบกับเราได้ที่สาขาลาดพร้าวและสาขาเมืองทองธานี
          Line : @wintershopthailand
          <br />เปิดบริการ 11:00-20:00 หยุดวันจันทร์
        </p>
      </div>

      <div class="col-lg-6 col-md-6 col-12">
        <div class="fancy-title title-border">
          <h4>Connect with Us</h4>
        </div>
        <div class="row">
          <div class="social_banner col-lg-4 col-md-4 col-4">
            <img :src="getFullPath('fb.jpg')" style="cursor:pointer; border-radius:10px;" />
          </div>
          <div class="social_banner col-lg-4 col-md-4 col-4">
            <img :src="getFullPath('ig_banner.jpg')" style="cursor:pointer;; border-radius:10px;" />
          </div>
          <div class="social_banner col-lg-4 col-md-4 col-4">
            <img :src="getFullPath('line_banner.jpg')" style="cursor:pointer;  border-radius:10px;" />
          </div>
        </div>
      </div>
    </div>-->
    <!-- row -->
  </div>
  <!-- ROOT -->
</template>

<script>
// @ is an alias to /src
// import carousel from "vue-owl-carousel";
// import Slide from "@/views/Slide.vue";

// import store from "@/store.js";
import axios from "axios";
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from "hooper";

import "hooper/dist/hooper.css";
import myMixins from "@/mixins/myMixins.js";
export default {
  name: "home",
  mixins: [myMixins],
  data() {
    return {
      dates: [],
      items: [],
      data: [
        '<div class="example-slide">Slide 1</div>',
        '<div class="example-slide">Slide 2</div>',
        '<div class="example-slide">Slide 3</div>',
      ],
    };
  },
  methods: {
    // getProductPath(mainImage) {
    //   if (mainImage === undefined || mainImage === null || mainImage === "") {
    //     return store.state.imageUrl + "defaultimage.png";
    //   } else {
    //     return "https://wintershop-online.com/webimage/item/" + mainImage;
    //   }
    // },
    // getFullPath(mainImage) {
    //   if (mainImage === undefined || mainImage === null || mainImage === "") {
    //     return store.state.imageUrl + "defaultimage.png";
    //   } else {
    //     return store.state.imageUrl + mainImage;
    //   }
    // },
    getLinkItem(productid) {
      return "https://wintershop-online.com/api/catalog/getitem/" + productid;
    },
    getProductID(productid) {
      return productid;
    },
    getProductName(productname) {
      return productname;
    },
  },
  mounted() {
    axios
      .get("https://wintershop-online.com/api/Nbs4u0m9pehXse/grouplist")
      .then((response) => {
        this.items = response.data.filter((x) => x.webHotItem === "ใช่");
      });
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
  },
};
</script>

<style>
.hooper-slide {
  width: 100% !important;
}

.hooper {
  height: auto !important;
  max-width: 1150px;
  margin-left: auto;
  margin-right: auto;
}

/* New rules if the window width is smaller than 1024px */
@media only screen and (max-width: 578px) {
  #theSlide {
    height: 250px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .nosmpadding {
    padding-left: 0 !important;
  }

  .imagefocus {
    height: 270px !important;
    margin-top: 20px !important;
  }

  .product-image {
    height: 170px !important;
  }

  .product,
  .iproduct {
    height: 270px !important;
  }
  .swiper_wrapper {
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    height: 270px !important;
  }
  .swiper-slide {
    width: 100% !important;
    height: auto !important;
  }
}
</style>
